/**
 * H2C Backend
 * An ASP.NET Core Web API for managing H2C User 
 *
 * The version of the OpenAPI document: V40:2026_02_04_10_21
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TCompanyTypeDTO } from './tCompanyTypeDTO';
import { TLocationDTO } from './tLocationDTO';


export interface TCompanyShortDTO { 
    company_id?: number;
    company_name?: string | null;
    company_location?: TLocationDTO;
    company_type?: TCompanyTypeDTO;
}

